import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { getApprovalFlow } from '../../services/approvalFlowService';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Tabs from '../../components/ui/Tabs';
import FlowStepsTab from './tab-pages/FlowStepsTab';
import FlowUsersTab from './tab-pages/FlowUsersTab';
import FlowRulesTab from './tab-pages/FlowRulesTab';
import { FLOW_TYPE_IDS } from './config/flowTypes';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

const StickyHeader = styled.div`
  flex-shrink: 0;
`;

// Kurallar sekmesinde tek kaydırma: PolicyRulesPanel kalan yüksekliği ölçer, yalnız tablo satırları kayar ($fill).
const TabContent = styled.div`
  flex: 1;
  min-height: 0;
  padding-top: 8px;
  ${({ $fill }) => ($fill
    ? 'display: flex; flex-direction: column; overflow: hidden;'
    : 'overflow-y: auto;')}
`;

export default function ApprovalFlowDetailsPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [flow, setFlow] = useState(null);
  const [activeTab, setActiveTab] = useState('steps');

  useEffect(() => {
    getApprovalFlow(id)
      .then((res) => setFlow(res.data?.data))
      .catch(() => {});
  }, [id]);

  // Kural türü olan tiplerde (Onay Akışları ekranında oluşturulabilen altı tip) canlı kurallar sekmesi
  // (spec 2026-11-01 §4.5); kişiye özel atamalar ayrı sekmede.
  const hasRules = !!flow && FLOW_TYPE_IDS.includes(flow.flowType);
  const tabs = [
    { key: 'steps', label: t('approvalFlow.tabSteps') },
    ...(hasRules ? [{ key: 'rules', label: t('approvalFlow.tabRules') }] : []),
    { key: 'users', label: hasRules ? t('approvalFlow.tabExceptions') : t('approvalFlow.tabUsers') },
  ];

  return (
    <PageContainer>
      <StickyHeader>
        <Breadcrumbs items={[
          { label: t('approvalFlow.title'), path: '/approval-flows' },
          { label: flow?.name || '...' },
        ]} />

        <Tabs tabs={tabs} activeTab={activeTab} onChange={setActiveTab} />
      </StickyHeader>

      <TabContent $fill={activeTab === 'rules'}>
        {activeTab === 'steps' && <FlowStepsTab flowId={id} />}
        {activeTab === 'rules' && hasRules && <FlowRulesTab flowId={id} flowType={flow.flowType} />}
        {activeTab === 'users' && <FlowUsersTab flowId={id} flowType={flow?.flowType} />}
      </TabContent>
    </PageContainer>
  );
}
